module.exports = __webpack_public_path__ + "img/store-speed-20_39.a7012df0.svg";